import { createFileRoute } from '@tanstack/react-router'
import { ForumSection } from '~/components/marketing/forum-section'
import { MarketingShell } from '~/components/marketing/marketing-shell'
import { TasksSection } from '~/components/marketing/tasks-section'
import { TimelineSection } from '~/components/marketing/timeline-section'
import { VisitsSection } from '~/components/marketing/visits-section'
import { marketingPageHead } from '~/lib/site-meta'

const PAGE_TITLE = 'Project work — projects, tasks and site visits | Planno'
const PAGE_DESCRIPTION =
  'A space per project, tasks in weekly sprints, a schedule in the vocabulary of architecture, and site visits captured on your phone.'

export const Route = createFileRoute('/en/features/project-work')({
  component: ProjectWorkPage,
  head: () =>
    marketingPageHead({
      description: PAGE_DESCRIPTION,
      locale: 'en',
      path: '/en/features/project-work',
      title: PAGE_TITLE,
    }),
})

function ProjectWorkPage() {
  return (
    <MarketingShell locale="en">
      <ForumSection headingLevel="h1" />
      <TasksSection />
      <TimelineSection />
      <VisitsSection />
    </MarketingShell>
  )
}
